export const iconFontAwesomeMusicVideoRadio = (
	<i className="fa-solid fa-radio"></i>
);
